// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608240839/js/" + chunkId + "." + {"44":"1f856d19","225":"740b2df1","481":"b17fffc2","486":"94871072","770":"97e3ad06"}[chunkId] + ".0.2858442831580581.chunk.js";
};